import HorizontalDirectionEnum from '@models/enums/HorizontalDirectionEnum';
import { IFeature } from '@models/IFeature';
import Feature from '@molecules/Feature/Feature';

const FeatureLeftFullWidth = (props: IFeature) => (
  <Feature {...props} fullWidth alignment={HorizontalDirectionEnum.Left} />
);

export default FeatureLeftFullWidth;
